import {timePattern} from "./patterns";

export function convertPositiveNumberWithDotToNumber(numberWithDot?: string): number | null {
  if (numberWithDot?.includes('.')) {
    numberWithDot = numberWithDot.replace(/\./g, '')
  }

  if (numberWithDot && Number.parseInt(numberWithDot) >= 0) {
    return parseInt(numberWithDot, 10);
  } else {
    return null;
  }
}

export function isValidVoterNumber(voterNumber: string): boolean {
  const numbersPart = voterNumber.slice(2);

  const hasWrongCharacter = numbersPart
      .split('')
      .some(character => character < '0' || character > '9');

  return !hasWrongCharacter && voterNumber.length === 9;
}

export function formatNumberWithDotSeparator(number: number, prefix = false): string {
  let options: Intl.NumberFormatOptions = {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }
  if(prefix){
    options.signDisplay = "exceptZero";
  }
  
  return number.toLocaleString('da-DK', options);
}

export function getNumberWithDotSeparator(number: number): number {
  const formattedNumber = number.toLocaleString('da-DK', {
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 20
  });

  const parts = formattedNumber.split('.');
  const integerPart = parts[0].replace(',', '');
  const decimalPart = parts[1] ? `.${parts[1].replace(',', '')}` : '';
  const formattedValue = `${integerPart}${decimalPart}`;

  return parseFloat(formattedValue);
}

export function getCprListDisplay(cprList: string[]): string {
  let displayString = "";
  cprList.forEach(x => {
    displayString += x + ", ";
  })
  return displayString.slice(0, -2) + ".";
}
export function camelToSnakeCase(str: string): string {
  return camelToSeparatedCase(str, '_');
}

export function camelToKebabCase(str: string): string {
  return camelToSeparatedCase(str, '-');
}

export function camelCase(str: string) {
  return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index)
  {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

function camelToSeparatedCase(str: string, separator: string) {
  return str?.toString().replace(/[A-Z]/g, (letter, index) => {
    return index == 0 ? letter.toLowerCase() : separator + letter.toLowerCase();
  });
}

export function formatTime(val: string): string | undefined {
  if (val.match(timePattern)) {
    const digitOnlyVal = val.replace(/[:.]/g, '')
    return `${digitOnlyVal.length === 3 ? '0' : ''}${digitOnlyVal.slice(0, -2)}:${digitOnlyVal.slice(-2)}`;
  }
  return undefined
}

export function tryGetNoneEmptyString(val: string | undefined): string | undefined {
  if (val) {
    return val;
  }
  return undefined;
}

export function isNullOrWhiteSpace(input?: string): boolean {
  return !input || !input.trim();
}

export function convertThousandSeparatorStringToNumber(string?: string) {
  return string ? parseInt(string.replace(/\./g, ''), 10) : undefined;
}
export function formatNullableNumberWithDotSeparator(number?: number): string | undefined {
  return (number !== null && number !== undefined) ? formatNumberWithDotSeparator(number) : undefined;
}
